import { OverlayContainer } from '@angular/cdk/overlay';

/** Clase en `.cdk-overlay-container` para subir z-index sobre el dock fijo (~1220). */
export const DOCK_LAUNCHER_OVERLAY_CONTAINER_CLASS = 'milinco-dock-launcher-overlay-boost';

/** Sube el overlay CDK por encima del dock; devolver la función limpia al cerrar el sheet. */
export function boostDockLauncherOverlay(overlayContainer: OverlayContainer): () => void {
  const el = overlayContainer.getContainerElement();
  el.classList.add(DOCK_LAUNCHER_OVERLAY_CONTAINER_CLASS);
  return () => el.classList.remove(DOCK_LAUNCHER_OVERLAY_CONTAINER_CLASS);
}
